import { UserDetail } from "@/models";
import { serviceApiInstance } from "@/utils/helper";

export async function getUserDetail(id: string): Promise<UserDetail> {
  return await serviceApiInstance
    .get<UserDetail>(`users/${id}`)
    .then((res) => res.data);
}

export async function getUserProfile(): Promise<UserDetail> {
  return await serviceApiInstance
    .get<UserDetail>(`me/profile`)
    .then((res) => res.data);
}

